module.exports = __webpack_public_path__ + "img/reddit.01571598.svg";